import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormControl} from '@angular/forms';
import { ConfigService } from '../../../services/config/config.service';
import { WallboardService } from 'src/app/services/wallboard/wallboard.service';

@Component({
  selector: 'app-wb-config-life',
  templateUrl: './wb-config-life.component.html',
  styleUrls: ['./wb-config-life.component.css']
})
export class WbConfigLifeComponent implements OnInit {

  @Output() public validationChange = new EventEmitter<any>();
  @Input() public activeConfigLife: any;
  @Input() public aggregateLife: boolean;

  queueList = new FormControl();

  constructor(
    public configService: ConfigService,
    public wallboardService: WallboardService
  ) { }

  ngOnInit() {
    console.log("ngOnInit for wb-config called");
    this.configService.getQueueList();
    console.log("activeConfigLife--", this.activeConfigLife)
    console.log("aggregateLife--", this.aggregateLife)
    
  }

}

